import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ConnectionStateService } from './shared/services/connection-state.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { TranslateService } from '@ngx-translate/core';
import { verifySession } from './store/actions/user.actions';
import { TxSession } from './shared/interfaces/session';
import { Store } from '@ngrx/store';
import { State } from './store/reducers';
import { AuthService } from './shared/services/auth.service';
import { Router } from '@angular/router';
import { FetchReports } from './store/actions/reports.actions';

declare var Messenger: any;

@Component({
	selector: 'tx-root',
	encapsulation: ViewEncapsulation.None,
	template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
	constructor(
		private connection: ConnectionStateService,
		private deviceDetection: DeviceDetectorService,
		private translationService: TranslateService,
		private authService: AuthService,
		private router: Router,
		private store: Store<State>
	) {
		translationService.setDefaultLang('de');

		// the lang to use, if the lang isn't available, it will use the current loader to get them
		translationService.use('de');
		translationService.get('txApplyBooking.status').subscribe();
	}

	ngOnInit(): void {
		// Restore session on app init
		// Only restore successfully authenticated sessions (statuscode: 0), not 2FA pending sessions
		let savedSession = sessionStorage.getItem('currentSession') || localStorage.getItem('currentSession');
		
		if (savedSession != null) {
			try {
				const session = JSON.parse(savedSession) as TxSession;
				
				// Only restore if session is fully authenticated (statuscode: 0)
				// Don't restore 2FA pending sessions (statuscode: -99)
				if (session && session.statuscode === 0 && session.sessionid !== '') {
					this.authService.redirectUrl = this.router.routerState.snapshot.url;
					this.store.dispatch(verifySession(session));
				} else {
					// Clear invalid or pending 2FA sessions
					sessionStorage.removeItem('currentSession');
					localStorage.removeItem('currentSession');
				}
			} catch (e) {
				console.log('Error restoring session:', e);
				sessionStorage.removeItem('currentSession');
				localStorage.removeItem('currentSession');
			}
		}

		// disable back button on mobile (experimental)
		if (this.deviceDetection.isMobile()) {
			history.pushState(null, null, location.href);
			window.onpopstate = () => {
				history.go(1);
			};
		}

		Messenger.options = {
			extraClasses: 'messenger-fixed messenger-on-top',
			theme: 'flat',
		};
	}
}
